import cn from 'clsx'
import ProgressBar, {
  ReactCustomizableProgressbarProps,
} from 'react-customizable-progressbar'

import './ProgressCircle.scss'
import {COLOR} from 'common/constants'

interface ProgressCircleProps {
  className?: string
  children?: JSX.Element | JSX.Element[]
  animation?: boolean
  green?: boolean
  radius: number
  value: number
  extraValue?: number
  strokeWidth: number
}

export default function ProgressCircle({
  className,
  children,
  animation,
  green,
  radius,
  strokeWidth,
  ...props
}: ProgressCircleProps) {
  const value = props.value > 100 ? 100 : props.value
  const extraValue = props.extraValue > 100 ? 100 : props.extraValue

  const options: ReactCustomizableProgressbarProps = {
    radius,
    initialAnimation: animation,
    progress: value,
    strokeLinecap: 'round',
  }

  const borderStrokeWidth = strokeWidth + 2
  const trackStrokeWidth = strokeWidth * 0.85
  const extraProgress = green ? extraValue : value + extraValue

  return (
    <div className={cn(className, 'ProgressCircle')}>
      <div
        className={cn(
          'ProgressCircle-Extra',
          green && 'ProgressCircle-Extra_outer'
        )}
      >
        <ProgressBar
          {...options}
          progress={extraProgress}
          strokeWidth={borderStrokeWidth}
          strokeColor={green ? COLOR.green : COLOR.turquoizeLightest}
          trackStrokeWidth={green ? 0 : trackStrokeWidth}
          trackStrokeColor={COLOR.mist50}
        />
      </div>
      <div className="ProgressCircle-Border">
        <ProgressBar
          {...options}
          strokeWidth={borderStrokeWidth}
          strokeColor={green ? COLOR.greenBright : COLOR.turquoizeDeep}
          trackStrokeWidth={green ? trackStrokeWidth : 0}
          trackStrokeColor={COLOR.mist50}
        />
      </div>
      <div className="ProgressCircle-Main">
        <ProgressBar
          {...options}
          strokeWidth={strokeWidth}
          strokeColor={green ? COLOR.greenLighter : COLOR.turquoizeBright}
          trackStrokeWidth={0}
        >
          {children && (
            <div className="ProgressCircle-Indicator">{children}</div>
          )}
        </ProgressBar>
      </div>
    </div>
  )
}
